export const SET_ALL_DATA_OF_ADMIN_USERS = 'SET_ALL_DATA_OF_ADMIN_USERS'

export const SET_FILTERED_ADMIN_USERS = 'SET_FILTERED_ADMIN_USERS'

export const SET_USERS_ADMIN_USERS = 'SET_USERS_ADMIN_USERS'

export const SET_PAGES_DATA_ADMIN_USERS = 'SET_PAGES_DATA_ADMIN_USERS'

export const RESTE_ALL_ADMIN_USERS_DATA = 'RESTE_ALL_ADMIN_USERS_DATA'

export const SET_SHOULD_UPDATE_ADMIN_USERS = 'SET_SHOULD_UPDATE_ADMIN_USERS'